/**
 * @name Sidebar.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * Header에서 선택한 메뉴 구성 (title)
 * 
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { BiChevronRight } from 'react-icons/bi';
import './Sidebar.css';
import { FaAlignJustify } from "react-icons/fa6";
const Sidebar = ({ activeMenu, isSidebarOpen }) => {

  const menus = [
    {
      id: 'mem',
      title: '회원관리',
      icon: <FaAlignJustify />,
      submenus: [
        { to: '/master/mem', label: '회원정보', icon: <BiChevronRight /> },
        { to: '/master/memall', label: '회원엑셀등록', icon: <BiChevronRight /> },
        { to: '/master/instr', label: '강사정보', icon: <BiChevronRight /> },
        { to: '/master/instrResult', label: '강사실적', icon: <BiChevronRight /> },
      ],
    },
    {
      id: 'comp',
      title: '업체관리',
      icon: <FaAlignJustify />,
      submenus: [
        { to: '/master/comp', label: '업체정보', icon: <BiChevronRight /> },
      ],
    },
    {
      id: 'edu',
      title: '교육관리',
      icon: <FaAlignJustify />,
      submenus: [
        { to: '/master/lecture', label: '강의정보', icon: <BiChevronRight /> },
        { to: '/master/integ', label: '통합수강생정보', icon: <BiChevronRight /> },
        { to: '/master/invoice', label: '통합세금계산서', icon: <BiChevronRight /> },
      ],
    },
    {
      id: 'sup',
      title: '지원관리',
      icon: <FaAlignJustify />,
      submenus: [
        // { to: '/master/notice', label: '공지사항', icon: <BiChevronRight /> },
        { to: '/master/refer', label: '자료실', icon: <BiChevronRight /> },
        // { to: '/master/inqu', label: '문의사항', icon: <BiChevronRight /> },
      ],
    },
    // {
    //   id: 'sys',
    //   title: '시스템관리',
    //   icon: <FaAlignJustify />,
    //   submenus: [
    //     { to: '/systemExcelUpload', label: '엑셀업로드', icon: <BiChevronRight /> },
    //   ],
    // },
  ];



  const activeMenuData = menus.find(menu => menu.id === activeMenu);

  if (!isSidebarOpen) return null;

  return (
    <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
      <ul className="sidebar-list">
        {activeMenuData && (
          <li>
            <div className="menu-title">
              <span className="icon">{activeMenuData.icon}</span>
              {activeMenuData.title}
            </div>
            <ul className="submenu-list">
              {activeMenuData.submenus.map((submenu, subIndex) => (
                <li key={subIndex}>
                  <Link to={submenu.to} className="submenu-link">
                    <span className="icon">{submenu.icon}</span>
                    {submenu.label}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
